<script setup lang="ts">
import type { MapBasemapMode } from '@gpx-spa/geo-domain';
import Globe from '@primeicons/vue/globe';
import Map from '@primeicons/vue/map';
import Button from 'primevue/button';
import { computed, onMounted, ref } from 'vue';
import { useGpxMapProvider } from '../composables/useGpxMapProvider';

export type GpxMapBasemapKind = MapBasemapMode;

/** Optional: keep parent state in sync when using v-model. */
const model = defineModel<MapBasemapMode>({ required: false });

const map = useGpxMapProvider();
/** Used when v-model is not bound; otherwise display follows model. */
const localMode = ref<MapBasemapMode>('streets');

const mode = computed(() => model.value ?? localMode.value);

onMounted(() => {
  if (model.value != null) {
    map.value.setBasemapMode(model.value);
  }
  localMode.value = map.value.getBasemapMode();
});

function toggle() {
  const next = mode.value === 'streets' ? 'satellite' : 'streets';
  map.value.setBasemapMode(next);
  const actual = map.value.getBasemapMode();
  localMode.value = actual;
  model.value = actual;
}
</script>

<template>
  <Button
    size="small"
    rounded
    severity="contrast"
    :aria-label="mode === 'streets' ? 'Basemap: map. Click to switch to satellite.' : 'Basemap: satellite. Click to switch to map.'"
    :title="mode === 'streets' ? 'Switch to satellite' : 'Switch to map'"
    @click="toggle"
  >
    <Map v-if="mode === 'streets'" />
    <Globe v-else />
    {{ mode === 'streets' ? 'Map' : 'Satellite' }}
  </Button>
</template>
